import React from 'react';
import { Handle } from 'reactflow';

function Table1Node({ data }) {
  return (
    <div
      style={{
        padding: 8,
        background: '#fff',
        border: '1px solid #ccc',
        textAlign: 'left',
        fontWeight: 500,
        width: `${data.width * 8 + 25}px`,
        margin: '0 8px 0 0',
        fontSize: 9,
      }}
    >
      <Handle type="source" position="right" />
      {data.label} <span style={{ fontWeight: 600, marginLeft: '2px' }}>[{data.datatype}]</span>
    </div>
  );
}

export default Table1Node;
